import { render, staticRenderFns } from "./PrivateJobPost.vue?vue&type=template&id=901aa5be"
import script from "./PrivateJobPost.vue?vue&type=script&lang=js"
export * from "./PrivateJobPost.vue?vue&type=script&lang=js"
import style0 from "./PrivateJobPost.vue?vue&type=style&index=0&id=901aa5be&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports